export default "__VITE_ASSET__D_uz0m6D__"